<div class="search-badges">
    <span *ngFor="let searchEl of searchByList | keyvalue" class="" class="search-badge">
        {{ getSearchFieldDisplayName(searchEl.key) }}:{{ searchEl.value }}
        <div class="clear-icon" (click)="clearElement(searchEl.key)">×</div>
    </span>
</div>